import { v4 as uuidv4 } from 'uuid';
import { getLogicNodeSchema } from '../Hasp/properties/v2/logic/index.js';
import { createAction } from '../utils/objectActions.js';
import { LOGIC_ID_PREFIX } from './logicGraph.js';

function actionCapability(type, preset) {
    return type === 'templateVisibility' ? `templateVisibility:${preset?.operation ?? 'show'}` : type;
}

/** Create a node of a schema-declared type. Action data has the shape of `createAction`, without its id. */
export function createLogicNode(type, { x = 0, y = 0, preset = {}, id } = {}) {
    const schema = getLogicNodeSchema(type);
    if (!schema) throw new Error(`Unknown logic node type "${type}"`);
    if (schema.kind !== 'action') {
        const data = { ...structuredClone(schema.defaults), ...preset };
        return { id: id ?? `${LOGIC_ID_PREFIX[schema.kind]}-${uuidv4()}`, kind: schema.kind, type, x, y, data };
    }
    const action = createAction(actionCapability(type, preset));
    delete action.id;
    return { id: id ?? `ac-${uuidv4()}`, kind: 'action', type, x, y, data: { ...action, ...preset } };
}
